import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  getOrderDetail,
  updateOrderDriver,
} from "../../redux/actions/orderActions";
import DefaultLayout from "../../layouts/DefaultLayout";
import Loader from "../../components/Loader";
import Alert from "../../components/Alert";
import { baseURL, baseURLFile } from "../../constants";
import { getListDrivers } from "../../redux/actions/driverActions";
import { toast } from "react-toastify";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { scroller } from "react-scroll";

function OrderDetailScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  let { id } = useParams();

  const [driverSelect, setDriverSelect] = useState("");
  const [driverSelectError, setDriverSelectError] = useState("");

  const [driverInfo, setDriverInfo] = useState(null);
  const [openDriverInfo, setOpenDriverInfo] = useState(false);

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const detailOrder = useSelector((state) => state.getDetailOrder);
  const {
    orderDetail,
    loadingOrderDetail,
    errorOrderDetail,
    successOrderDetail,
  } = detailOrder;

  const listDrivers = useSelector((state) => state.getListDrivers);
  const { drivers, loadingListDrivers, errorListDrivers, pages } = listDrivers;

  const orderDriverUpdate = useSelector((state) => state.updateOrderDriver);
  const {
    loadingOrderDriverUpdate,
    errorOrderDriverUpdate,
    successOrderDriverUpdate,
  } = orderDriverUpdate;

  const redirect = "/";
  useEffect(() => {
    if (!userInfo) {
      navigate(redirect);
    } else {
      dispatch(getOrderDetail(id));
      dispatch(getListDrivers(0));
    }
  }, [navigate, userInfo, dispatch, id]);

  useEffect(() => {
    if (successOrderDriverUpdate) {
      dispatch(getOrderDetail(id));
      dispatch(getListDrivers(0));
    }
  }, [successOrderDriverUpdate]);

  const getExtraItems = (extras) => {
    var name = "";

    extras?.map((item) => {
      if (name !== "") {
        name += ", ";
      }
      name += item.extra_item?.item_name ?? "";
      if (item.extra_item?.item_price && item.extra_item?.item_price !== 0) {
        name += `(+${parseFloat(item.extra_item?.item_price).toFixed(2)}$)`;
      }
    });

    return name;
  };

  const storeIcon = new L.Icon({
    iconUrl: "/assets/icons/shopping-store.png", // Example icon URL, you can use a custom green one
    iconSize: [32, 32],
    iconAnchor: [16, 32],
    popupAnchor: [0, -32],
  });

  const driverIcon = new L.Icon({
    iconUrl: "/assets/icons/moto-driver.png", // Example icon URL, you can use a custom blue one
    iconSize: [32, 32],
    iconAnchor: [16, 32],
    popupAnchor: [0, -32],
  });

  const clientIcon = new L.Icon({
    iconUrl: "/assets/icons/client-icon.png", // Example icon URL, you can use a custom red one
    iconSize: [32, 32],
    iconAnchor: [16, 32],
    popupAnchor: [0, -32],
  });

  return (
    <DefaultLayout>
      <div>
        <div className="flex flex-row text-sm items-center my-1">
          {/* home */}
          <a href="/dashboard">
            <div className="flex flex-row  items-center hover:text-black ">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                className="w-4 h-4"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
                />
              </svg>
              <span className="mx-1">Dashboard</span>
            </div>
          </a>
          <a href="/orders">
            <div className="flex flex-row  items-center hover:text-black ">
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  className="w-4 h-4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="m8.25 4.5 7.5 7.5-7.5 7.5"
                  />
                </svg>
              </span>
              <div className="">Order List</div>
            </div>
          </a>
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m8.25 4.5 7.5 7.5-7.5 7.5"
              />
            </svg>
          </span>
          <div className="">Order Detail</div>
        </div>
        {/*  */}
        <div className="flex flex-row justify-between  items-center my-3">
          <div className="mx-1 font-bold text-black ">Order Detail</div>
        </div>
        {/*  */}
        {loadingOrderDetail ? (
          <Loader />
        ) : errorOrderDetail ? (
          <Alert type={"error"} message={errorOrderDetail} />
        ) : orderDetail ? (
          <>
            {orderDetail.orderItems?.length === 0 ? (
              <Alert type={"error"} message={"Order is empty"} />
            ) : (
              <>
                <div className="rounded-sm border border-stroke bg-white px-5 py-5 shadow-default   dark:bg-boxdark  my-3">
                  <div className="container mx-auto flex flex-col">
                    <div className="mt-3 mb-1 font-bold text-black">
                      #{orderDetail.id ?? id}
                    </div>
                    <div className="my-1 font-bold text-black">
                      Status: {orderDetail.order_status ?? ""}
                    </div>
                    <div className="mt-1  font-bold text-black">
                      Total: {parseFloat(orderDetail.total_order).toFixed(2)} $
                    </div>
                    {orderDetail.store ? (
                      <div className="mt-1 mb-3 font-bold text-black">
                        Store Name: {orderDetail.store?.store_name ?? "---"}
                      </div>
                    ) : null}
                    <div className="flex md:flex-row flex-col">
                      <div className="md:w-1/2 w-full p-3">
                        <h1>
                          <span className="border-b font-bold text-black text-xl">
                            Customer info
                          </span>
                        </h1>
                        <div>
                          <div className="py-3">
                            <div>
                              <b className="text-black ">First Name</b> :{" "}
                              {orderDetail.first_name ?? "---"}
                            </div>
                            <div>
                              <b className="text-black ">Last Name</b> :{" "}
                              {orderDetail.last_name ?? "---"}
                            </div>
                            <div>
                              <b className="text-black ">Email</b> :{" "}
                              {orderDetail.email ?? "---"}
                            </div>
                            <div>
                              <b className="text-black ">Phone Number</b> :{" "}
                              {orderDetail.phone ?? "---"}
                            </div>
                            {orderDetail.delivery_type === "PICKUP" ? (
                              <></>
                            ) : (
                              <div>
                                <b className="text-black ">Address</b> :{" "}
                                {orderDetail.address ?? "---"}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="md:w-1/2 w-full p-3" id="driverinfoid">
                        <h1>
                          <span className="border-b font-bold text-black text-xl">
                            Driver info
                          </span>
                        </h1>
                        {orderDetail.delivery_type === "PICKUP" ? (
                          <div className="py-3">
                            <div className="text-black text-md">
                              Customer Select Delivery Type: <b>PICKUP</b>
                            </div>
                          </div>
                        ) : (
                          <div className="py-3">
                            {orderDetail.delivery ? (
                              <>
                                <div>
                                  <b className="text-black ">First Name</b> :{" "}
                                  {orderDetail.delivery?.first_name ?? "---"}
                                </div>
                                <div>
                                  <b className="text-black ">Last Name</b> :{" "}
                                  {orderDetail.delivery?.last_name ?? "---"}
                                </div>
                                <div>
                                  <b className="text-black ">Email</b> :{" "}
                                  {orderDetail.delivery?.email ?? "---"}
                                </div>
                                <div>
                                  <b className="text-black ">Phone Number</b> :{" "}
                                  {orderDetail.delivery?.phone ?? "---"}
                                </div>
                              </>
                            ) : (
                              <>
                                <div className="flex md:flex-row flex-col  ">
                                  <div className="w-full  md:pr-1 my-1">
                                    <div className="text-[#000000bf] font-bold text-xs  mb-1">
                                      Select Driver{" "}
                                      <strong className="text-danger">*</strong>
                                    </div>
                                    <div>
                                      <select
                                        className={` outline-none border ${
                                          driverSelectError
                                            ? "border-danger"
                                            : "border-[#979fd38a]"
                                        } px-3 py-2 w-full rounded text-sm`}
                                        value={driverSelect}
                                        onChange={(v) =>
                                          setDriverSelect(v.target.value)
                                        }
                                      >
                                        <option value={""}></option>
                                        {drivers?.map((item, index) => (
                                          <option value={item.id}>
                                            {item.full_name}
                                          </option>
                                        ))}
                                      </select>
                                      <div className=" text-[8px] text-danger">
                                        {driverSelectError
                                          ? driverSelectError
                                          : ""}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="my-3 ">
                                  <div className="flex flex-row items-center justify-end my-3">
                                    <a
                                      href="/categories"
                                      className="bg-white text-[#0388A6] text-sm px-5 py-3 rounded-full mr-3"
                                    >
                                      Back
                                    </a>
                                    <button
                                      disabled={loadingOrderDriverUpdate}
                                      onClick={async () => {
                                        var check = true;
                                        setDriverSelectError("");

                                        if (driverSelect === "") {
                                          setDriverSelectError(
                                            "These fields are required."
                                          );
                                          check = false;
                                        }

                                        if (check) {
                                          // setLoadEvent(true);
                                          await dispatch(
                                            updateOrderDriver(id, driverSelect)
                                          ).then(() => {});
                                          // setLoadEvent(false);
                                        } else {
                                          toast.error(
                                            "Some fields are empty or invalid. please try again"
                                          );
                                        }
                                      }}
                                      className="text-white bg-[#0388A6] text-sm px-5 py-3 rounded-full"
                                    >
                                      {loadingOrderDriverUpdate
                                        ? "Loading ..."
                                        : "Confirm"}
                                    </button>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {/* maps */}
                <div className="rounded-sm border border-stroke bg-white px-5 py-5 shadow-default   dark:bg-boxdark  my-3 relative">
                  <div className="relative">
                    <MapContainer
                      center={
                        orderDetail.store &&
                        orderDetail.store.location_x != null &&
                        orderDetail.store.location_y != null
                          ? [
                              orderDetail.store.location_x,
                              orderDetail.store.location_y,
                            ] // Store location
                          : [0, 0] // Default to the center of the world
                      }
                      zoom={6}
                      style={{ height: "500px", width: "100%" }}
                    >
                      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

                      {/* drivers */}

                      {drivers &&
                        drivers
                          .filter(
                            (driver) =>
                              driver.location_x != null &&
                              driver.location_y != null
                          ) // Filter out invalid locations
                          .map((driver, index) => (
                            <Marker
                              key={index}
                              icon={driverIcon}
                              position={[driver.location_x, driver.location_y]}
                              eventHandlers={{
                                click: () => {
                                  setDriverInfo(driver);
                                  setOpenDriverInfo(true);
                                },
                              }}
                            >
                              <Popup>🚗 Driver: {driver.full_name}</Popup>
                            </Marker>
                          ))}

                      {orderDetail.store &&
                        orderDetail.store.location_x != null &&
                        orderDetail.store.location_y != null && (
                          <Marker
                            position={[
                              orderDetail.store.location_x,
                              orderDetail.store.location_y,
                            ]}
                            icon={storeIcon}
                          >
                            <Popup>
                              🏬 Store: {orderDetail.store.store_name ?? ""}
                            </Popup>
                          </Marker>
                        )}

                      {orderDetail.delivery_type === "DELIVERY" &&
                        orderDetail.location_x != null &&
                        orderDetail.location_y != null && (
                          <Marker
                            icon={clientIcon}
                            position={[
                              orderDetail.location_x,
                              orderDetail.location_y,
                            ]}
                          >
                            <Popup>
                              👤 Client: {orderDetail.user.full_name}
                            </Popup>
                          </Marker>
                        )}
                    </MapContainer>

                    {openDriverInfo && driverInfo ? (
                      <div className=" absolute top-0 left-0 z-99999  p-2 md:w-1/3 w-2/3 h-full ">
                        <div className="bg-white shadow-1 w-full h-full">
                          <div className=" p-3 float-right ">
                            <button
                              onClick={() => {
                                setOpenDriverInfo(false);
                                setDriverInfo(null);
                              }}
                              className="rounded-full p-1 bg-danger shadow-1 text-white flex items-center w-max "
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                className="size-4"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  d="M6 18 18 6M6 6l12 12"
                                />
                              </svg>
                            </button>
                          </div>
                          <div className="pt-10 py-4 px-3">
                            {driverInfo && (
                              <div>
                                <div className="flex flex-row items-center text-xs my-3">
                                  <div>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke-width="1.5"
                                      stroke="currentColor"
                                      className="size-4"
                                    >
                                      <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z"
                                      />
                                    </svg>
                                  </div>
                                  <div className="flex-1 px-2">
                                    {driverInfo.full_name ?? "---"}
                                  </div>
                                </div>
                                {/*  */}

                                <div className="flex flex-row items-center text-xs my-3">
                                  <div>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke-width="1.5"
                                      stroke="currentColor"
                                      className="size-5"
                                    >
                                      <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
                                      />
                                    </svg>
                                  </div>
                                  <div className="flex-1 px-2">
                                    {driverInfo.email ?? "---"}
                                  </div>
                                </div>
                                {/*  */}
                                <div className="flex flex-row items-center text-xs my-3">
                                  <div>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke-width="1.5"
                                      stroke="currentColor"
                                      className="size-5"
                                    >
                                      <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z"
                                      />
                                    </svg>
                                  </div>
                                  <div className="flex-1 px-2">
                                    {driverInfo.phone ?? "---"}
                                  </div>
                                </div>
                                {/*  */}
                                <div className="flex flex-row items-center text-xs my-3">
                                  <div>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke-width="1.5"
                                      stroke="currentColor"
                                      className="size-4"
                                    >
                                      <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                                      />
                                      <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
                                      />
                                    </svg>
                                  </div>
                                  <div className="flex-1 px-2">
                                    {driverInfo.city ?? "---"}
                                  </div>
                                </div>

                                <p className="text-black  text-xs w-max flex flex-row my-4 ">
                                  <div
                                    onClick={() => {
                                      setDriverSelect(driverInfo.id);
                                      setOpenDriverInfo(false);
                                      setDriverInfo(null);
                                      // Smooth scroll to #driverinfoid

                                      scroller.scrollTo("driverinfoid", {
                                        duration: 800, // Duration in milliseconds
                                        smooth: "easeInOutQuad", // Animation easing
                                        offset: -50, // Adjust this value if needed (e.g., for fixed headers)
                                      });
                                    }}
                                    className="mx-1  cursor-pointer bg-danger text-white font-bold px-3 py-2 rounded"
                                  >
                                    <div className="">Select this Driver</div>
                                  </div>
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
                {/*  */}
                <div className="rounded-sm border border-stroke bg-white px-5 py-5 shadow-default   dark:bg-boxdark  my-3 text-black">
                  <div className="container mx-auto flex flex-col">
                    <h1>
                      <span className="border-b">Items</span>
                    </h1>
                    {orderDetail.items?.map((item, index) => (
                      <div className="pt-3" key={index}>
                        <div className="flex py-2 items-center border-b justify-between">
                          <div className="flex ">
                            <img
                              src={baseURLFile + item.product?.product_image}
                              alt={item.product?.product_name}
                              className="size-14 rounded-xl object-cover"
                            />
                            <div className="pl-4">
                              <div className="text-md font-bold text-black ">
                                {item.product?.product_name}
                              </div>
                              <div className="text-opacity-90 text-xs ">
                                <p>{getExtraItems(item.extra_items ?? [])}</p>
                              </div>
                              <div className="text-opacity-90  font-bold text-xs">
                                Price :{" "}
                                {parseFloat(
                                  item.product?.product_price
                                ).toFixed(2)}{" "}
                                $
                              </div>
                              {/* <div className="text- opacity-90 " >Organizer : {item.organizer} </div> */}
                            </div>
                          </div>
                          <div className="font-bold text-sm">
                            {item.quantity} x{" "}
                            {parseFloat(item.product?.product_price).toFixed(2)}{" "}
                            $ ={" "}
                            {item.quantity *
                              parseFloat(item.product?.product_price)}{" "}
                            $
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                {/*  */}

                <div className=" px-5 py-5  dark:bg-boxdark  text-black">
                  <div className="container mx-auto flex flex-row justify-end  w-full">
                    <div className="py-3 float-right  shadow-default  bg-white  rounded-md px-5  mt-3 w-max">
                      <div className="pt-3 text-sm">
                        Created At : {orderDetail.created_at} <br />
                      </div>
                      <div className="py-2 font-semibold">
                        Total :{parseFloat(orderDetail.total_order).toFixed(2)}{" "}
                        $
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </>
        ) : null}
      </div>
    </DefaultLayout>
  );
}

export default OrderDetailScreen;
